import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FileStatusButton, FileStatusPanelItem, FileStatusSubtitle, FileStatusTitle } from "@air/feature-file-status/ui";
import { Close, Play } from "@air/next-icons";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo, useCallback, useState } from "react";
import { getSubtitleWithProgress } from "../../utils";
import { FileStatusThumbnail } from "./FileStatusThumbnail";
export const FileStatusTrackingPanelListItemStopped = /*#__PURE__*/ memo((param)=>{
    let { item, onCancel, onResume, item: { ext, onRowClick, previewLoader, avatar, title, thumbnailSource, sizeInBytes, subtitle, status } } = param;
    const [isResuming, setIsResuming] = useState(false);
    const handleResume = useCallback(async ()=>{
        setIsResuming(true);
        try {
            await (onResume === null || onResume === void 0 ? void 0 : onResume(item));
        } finally{
            setIsResuming(false);
        }
    }, [
        onResume,
        item
    ]);
    return /*#__PURE__*/ _jsx(FileStatusPanelItem, {
        onClick: onRowClick,
        className: tailwindMerge("mx-1.5 rounded-4 px-2.5 py-1.5 transition-all duration-200", !!onRowClick && "cursor-pointer hover:bg-grey-3"),
        previewLoader: previewLoader,
        avatar: avatar !== null && avatar !== void 0 ? avatar : /*#__PURE__*/ _jsx(FileStatusThumbnail, {
            ext: ext,
            status: status,
            thumbnailSource: thumbnailSource
        }),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            children: title
        }),
        subtitle: /*#__PURE__*/ _jsx(FileStatusSubtitle, {
            className: "truncate",
            children: subtitle !== null && subtitle !== void 0 ? subtitle : getSubtitleWithProgress({
                title: "Stopped",
                uploadedBytes: sizeInBytes,
                sizeInBytes
            })
        }),
        buttons: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                onResume && /*#__PURE__*/ _jsx(FileStatusButton, {
                    onClick: handleResume,
                    label: "Resume",
                    isLoading: isResuming,
                    children: /*#__PURE__*/ _jsx(Play, {
                        className: "size-4"
                    })
                }),
                onCancel && /*#__PURE__*/ _jsx(FileStatusButton, {
                    onClick: ()=>onCancel(item),
                    label: "Cancel",
                    children: /*#__PURE__*/ _jsx(Close, {
                        className: "size-4"
                    })
                })
            ]
        })
    });
});
FileStatusTrackingPanelListItemStopped.displayName = "FileStatusTrackingPanelListItemStopped";
